import React from 'react';
import FilterListIcon from '@mui/icons-material/FilterList';

import { formatCount } from './bulkVerificationFormat';
import { MAX_SELECTED_ENTITIES } from './bulkVerificationCandidates';

export type BulkVerificationScopeChoice = 'selected' | 'all';

interface BulkVerificationScopeStepProps {
  scope: BulkVerificationScopeChoice;
  onScopeChange: (scope: BulkVerificationScopeChoice) => void;
  databaseName: string;
  selectedCount: number;
  entityCount?: number;
  filtersActive: boolean;
  /** Shown under the options while "Selected entities" is chosen. */
  picker: React.ReactNode;
}

/** Step 1: which Database Entities the run covers. */
const BulkVerificationScopeStep: React.FC<BulkVerificationScopeStepProps> = ({
  scope,
  onScopeChange,
  databaseName,
  selectedCount,
  entityCount,
  filtersActive,
  picker,
}) => (
  <>
    <div
      className='bdb-bulk-verify-scopes'
      role='radiogroup'
      aria-label='Which entities'
    >
      <button
        type='button'
        role='radio'
        aria-checked={scope === 'selected'}
        className='bdb-bulk-verify-scope'
        onClick={() => onScopeChange('selected')}
      >
        <span className='bdb-bulk-verify-radio' aria-hidden='true' />
        <span className='bdb-bulk-verify-scope-title'>
          Selected entities
          <span className='bdb-bulk-verify-num'>
            {' '}
            ({formatCount(selectedCount)})
          </span>
        </span>
        <span className='bdb-bulk-verify-scope-text'>
          Choose records below. Up to {formatCount(MAX_SELECTED_ENTITIES)} per
          run.
        </span>
      </button>
      <button
        type='button'
        role='radio'
        aria-checked={scope === 'all'}
        className='bdb-bulk-verify-scope'
        onClick={() => onScopeChange('all')}
      >
        <span className='bdb-bulk-verify-radio' aria-hidden='true' />
        <span className='bdb-bulk-verify-scope-title'>
          All entities in this database
          {entityCount !== undefined && (
            <span className='bdb-bulk-verify-num'>
              {' '}
              ({formatCount(entityCount)})
            </span>
          )}
        </span>
        <span className='bdb-bulk-verify-scope-text'>
          Every entity in {databaseName}, as it stands when the run starts.
        </span>
        {filtersActive && (
          <span className='bdb-bulk-verify-scope-note'>
            <FilterListIcon sx={{ fontSize: 16 }} aria-hidden='true' />
            <span>
              Your list filters don&apos;t apply here. All
              {entityCount !== undefined
                ? ` ${formatCount(entityCount)}`
                : ''}{' '}
              entities are included, not just the ones that match.
            </span>
          </span>
        )}
      </button>
    </div>
    {scope === 'selected' && picker}
  </>
);

export default BulkVerificationScopeStep;
